export default __webpack_public_path__ + "d3ca519e120f1aaa1726d0c7ceff8a30.svg";